import { render, staticRenderFns } from "./AulaModal.vue?vue&type=template&id=d35fd2bc&scoped=true"
import script from "./AulaModal.vue?vue&type=script&lang=js"
export * from "./AulaModal.vue?vue&type=script&lang=js"
import style0 from "./AulaModal.vue?vue&type=style&index=0&id=d35fd2bc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d35fd2bc",
  null
  
)

export default component.exports